import spechtotext from "../assets/portfolio pic/speechToText.png";
import todoListLocalStorage from "../assets/portfolio pic/todoListLocalStorage.png";
import twitterPage from "../assets/portfolio pic/twitterPage.png";
import enentPlanner from "../assets/portfolio pic/enentPlanner.png";
import dropideaLandingPage from "../assets/portfolio pic/dropideaLandingPage.png";
import burgerHouseLandingPage from "../assets/portfolio pic/burgerHouseLandingPage.png";
import musicologyLandingPage from "../assets/portfolio pic/musicologyLandingPage.png";
import githubProfilePic from "../assets/portfolio pic/githubProfilePic.png";

export const ProjectData = [
  {
    id: 1,
    img: spechtotext,
    name: "Speech to text converter",
    description: [
      "React.js",
      "javascript",
      "html",
      "scss",
      "Bootestrap",
      "npm",
    ],
    link: "https://speechtotextbyzeeshan.netlify.app/",
  },
  {
    id: 2,
    img: todoListLocalStorage,
    name: "Todo list Local Storage",
    description: [
      "React.js",
      "javascript",
      "local storage",
      "html",
      "scss",
      "Bootestrap",
    ],
    link: "https://todoappwithlocalstoragebyzeeshan.netlify.app/",
  },
  {
    id: 3,
    img: enentPlanner,
    name: "Event Planner",
    description: [
      "React.js",
      "javascript",
      "firebase",
      "firebase-auth",
      "firebase-storage",
      "react toastify",
      "Bootestrap",
    ],
    link: "https://envenplannerbyzeeshan.netlify.app/",
  },
  {
    id: 4,
    img: dropideaLandingPage,
    name: "Dropidea landing page",
    description: ["react.js", "html", "scss", "Bootestrap", "Responsive"],
    link: "https://dropidealandingpagebyzeeshan.netlify.app/",
  },
  {
    id: 5,
    img: twitterPage,
    name: "Twitter home page",
    description: [
      "html",
      "css",
      "Bootestrap",
      "Responsive",
      "font Awesome icons",
    ],
    link: "https://twitterhomepagebyzeeshan.netlify.app/",
  },
  {
    id: 6,
    img: burgerHouseLandingPage,
    name: "Burger house landing page",
    description: [
      "html",
      "css",
      "Bootestrap",
      "Responsive",
      "font Awesome icons",
    ],
    link: "http://bootstrapweb2.surge.sh/",
  },
  {
    id: 7,
    img: musicologyLandingPage,
    name: "Musicology landing page ",
    description: [
      "html",
      "css",
      "Bootestrap",
      "Responsive",
      "font Awesome icons",
    ],
    link: "http://bootstrapweb1.surge.sh/",
  },
  {
    id: 8,
    img: githubProfilePic,
    name: "I make more then 50 projects you can check on my github profile",
    description: [
      "React.js",
      "javascript",
      "typescript",
      "html",
      "css",
      "scss",
      "Bootestrap",
    ],
    link: "https://github.com/Zeeshankhaliq219",
  },
];
